const TZ = "Europe/Paris"

export function euros(amount: number | null | undefined): string {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(Number(amount ?? 0))
}

export function dateLongue(d: string | Date | null | undefined): string {
  if (!d) return ""
  return new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, day: "numeric", month: "long", year: "numeric" }).format(new Date(d))
}

export function dateHeure(d: string | Date | null | undefined): string {
  if (!d) return ""
  const date = new Date(d)
  const jour = new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, weekday: "long", day: "numeric", month: "long" }).format(date)
  const heure = new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }).format(date)
  return `${jour} à ${heure.replace(":", " h ")}`
}

export function dateCourte(d: string | Date | null | undefined): string {
  if (!d) return ""
  return new Intl.DateTimeFormat("fr-FR", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }).format(new Date(d))
}

export function horodatage(d: string | Date | null | undefined): string {
  if (!d) return ""
  return new Intl.DateTimeFormat("fr-FR", {
    timeZone: TZ,
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(d)) + " (heure de Paris)"
}

export function paragraphs(text: string | null | undefined): string[] {
  return (text ?? "").split(/\n{2,}|\r\n\r\n/).map((p) => p.trim()).filter(Boolean)
}

export const KIND_LABELS: Record<string, string> = {
  unique: "Pièce unique",
  serie: "Petite série",
  exemplaire: "Pièce unique", // Compatibilité avec les fiches créées avant la simplification.
  personnalisable: "Personnalisable",
}
